<script setup lang="ts">
import MountedTeleport from '@/components/MountedTeleport.vue';
import ToggleWithDescription from '@/components/ui/toggles/ToggleWithDescription.vue';
import ToggleWithIcon from '@/components/ui/toggles/ToggleWithIcon.vue';
import RefinementListCard from '../RefinementListCard.vue';
import RefinementList from '../RefinementList.vue';
import { ref } from 'vue';

const showFilters = ref(true);
</script>
<template>
  <MountedTeleport to="#advanced-filters">
    <div class="my-8 w-52">
      <!-- <ToggleWithDescription v-model="showFilters" label="Afficher les filtres" /> -->
      <div class="inline-flex items-center">
        <ToggleWithIcon v-model="showFilters" :default-value="showFilters" label="Afficher les filtres" />
        <p class="ml-3 text-base font-semibold">Afficher les filtres</p>
      </div>
    </div>
    <div v-show="showFilters">
      <div class="flex px-8 mb-4 text-left border shadow-sm rounded-xl border-slate-200 bg-gray-50 gap-x-6">
        <div>
          <RefinementList attribute="procedureJuridiction.name" attribute-name="Tribunal sélectionné" size="xl" />
        </div>
        <div>
          <RefinementList attribute="groupNames" attribute-name="Groupes (vagues)" size="lg" />
        </div>
        <div>
          <RefinementList attribute="numeroRG" attribute-name="Numéro RG" size="lg" />
        </div>
      </div>
      <div class="flex px-4 py-6 mb-6 space-x-16 rounded-lg ring-2 bg-blue-50">
        <div>
          <RefinementListCard attribute="enrolmentStatus" attribute-name="Dossier enrôlé au tribunal ?" size="lg" />
        </div>
        <div>
          <RefinementListCard attribute="procedureType" attribute-name="Type de procédure" size="lg" />
        </div>
        <div>
          <RefinementListCard attribute="isInProcedureWave" attribute-name="Est dans une vague de procédure ?" size="lg" />
        </div>
      </div>
    </div>
  </MountedTeleport>
</template>